import _ from 'lodash';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter, type Event } from '@patsnap/tahiti-core/common/event';
import type { Patent } from '../type/patents-list.type';

export const PatentsListService = Symbol('PatentsListService');

export interface PatentsListService{
    onSelectedChange: Event<Patent[]>;
    onListVisibleChange: Event<boolean>;
    onIdListChange: Event<string[]>;
    idList: string[]
    selectedList: Patent[];
    isShowList: boolean;
    setSelected(target: Patent): void;
    setListVisible(value: boolean): void;
    setIdList(value: string[]): void;
}

@injectable()
export class PatentsListServiceImpl implements PatentsListService {
    private _onSelectedEmitter = new Emitter<Patent[]>();
    readonly onSelectedChange = this._onSelectedEmitter.event;
    private _onListVisibleEmitter = new Emitter<boolean>();
    readonly onListVisibleChange = this._onListVisibleEmitter.event;
    private _onIdListEmitter = new Emitter<string[]>();
    readonly onIdListChange = this._onIdListEmitter.event;

    private _selectedList: Patent[] = [];
    private _isShowList = true;
    private _idList: string[] = [];

    public get selectedList() {
        return _.cloneDeep(this._selectedList);
    }

    public get isShowList() {
        return this._isShowList;
    }

    public get idList() {
        return this._idList;
    }

    public setSelected(target: Patent) {
        const list = this.selectedList;

        const matchedIndex = _.findIndex(list, item => target.PATENT_ID === item.PATENT_ID);

        if (matchedIndex === -1) {
            list.push(target);
        } else {
            list.splice(matchedIndex, 1);
        }

        this._selectedList = list;
        this._onSelectedEmitter.fire(this.selectedList);
    }

    public setListVisible(value: boolean) {
        this._isShowList = value;
        this._onListVisibleEmitter.fire(this.isShowList);
    }

    public setIdList(value: string[]) {
        this._idList = value;
        this._onIdListEmitter.fire(this.idList);
    }
}
